<template>
  <v-col v-if="!!budgetLength" cols="12">
    <v-row no-gutters>
      <v-col cols="12" class="pa-0 pb-4">
        <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
          Presupuestos
        </h6>
      </v-col>

      <v-col cols="12" class="pa-0">
        <div class="budget-list">
          <div
            v-for="item in budgetList"
            :key="item.id"
            class="d-flex align-center justify-space-between pa-3 visit"
            style="cursor: pointer; border-radius: 5px"
            :class="{
              highlighted: item.status_budget.id == 2,
              regular: item.status_budget.id != 2,
            }"
            @click="showBudgetDetail(item)"
          >
            <div class="d-flex align-center">
              <v-icon
                v-if="item.status_budget.id == 1"
                color="#1565c0"
                :class="{ dim: fab }"
              >
                note_add
              </v-icon>

              <v-icon
                v-else-if="item.status_budget.id == 2"
                color="success"
                :class="{ dim: fab }"
              >
                check_circle
              </v-icon>

              <v-icon
                v-else-if="item.status_budget.id == 3"
                color="success"
                :class="{ dim: fab }"
              >
                check_circle
              </v-icon>

              <v-icon
                v-else-if="item.status_budget.id == 4"
                color="error"
                :class="{ dim: fab }"
              >
                remove_circle
              </v-icon>

              <v-icon
                v-else-if="item.status_budget.id == 5"
                color="#ff8f00"
                :class="{ dim: fab }"
              >
                help
              </v-icon>

              <v-icon
                v-else-if="item.status_budget.id == 6"
                color="#ff8f00"
                :class="{ dim: fab }"
              >
                find_in_page
              </v-icon>

              <v-icon
                v-else-if="item.status_budget.id == 7"
                color="error"
                :class="{ dim: fab }"
              >
                error
              </v-icon>

              <div class="ml-2">
                <p
                  style="margin-bottom: 0px; font-size: 13px; font-weight: bold"
                >
                  {{ item.status_budget.name }}
                </p>
                <p style="margin-bottom: 0; text-transform: capitalize">
                  {{ formatDate(item.created_at) }}
                </p>
                <p style="margin-bottom: 0">{{ totalAmount(item) }}</p>
              </div>
            </div>

            <v-icon color="#9e9e9e" :class="{ dim: fab }">
              keyboard_arrow_right
            </v-icon>
          </div>
        </div>
      </v-col>

      <v-col
        v-if="budgetLength > 2"
        cols="12"
        class="pa-0 pt-6 showAll d-flex justify-center"
      >
        <v-btn text style="color: #1565c0; font-weight: 400" @click="showAll()">
          Ver todos los presupuestos ({{ budgetLength }})
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  props: {
    requestId: Number,
  },
  mounted() {
    this.getBudgetList();
  },
  data: () => ({
    budgetList: [],
    budgetLength: 0,
    fab: false,
  }),
  methods: {
    showAll() {
      this.$router.push({
        name: "budget-list",
        query: { request_id: this.requestId },
      });
    },
    showBudgetDetail(budget) {
      if (budget) {
        this.$store.commit("set_current_budget", budget);
      } else {
        this.$store.commit("set_current_budget", {});
      }

      this.$router.push({ name: "budget-detail" });
    },
    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },
    totalAmount: function (item) {
      if (item.supplies_budget && item.manpower_budget) {
        return (
          "$" + (Number(item.supplies_budget) + Number(item.manpower_budget))
        );
      }
      if (item.supplies_budget) {
        return "$" + Number(item.supplies_budget);
      }
      if (item.manpower_budget) {
        return "$" + Number(item.manpower_budget);
      }
      return "$ -";
    },
    getBudgetList() {
      this.axios
        .get(`/budget/?request_id=${this.requestId}`)
        .then((response) => {
          this.budgetLength = response.data.results.length;
          if (this.budgetLength <= 2) {
            this.budgetList = response.data.results;
          } else {
            this.budgetList = this.filterBudgetList(response.data.results);
          }
        })
        .catch(() => {});
    },
    filterBudgetList(budgetList) {
      let pending = budgetList.filter((item) => item.status_budget.id == 5);
      let approved = budgetList.filter((item) => item.status_budget.id === 2);
      let rest = budgetList.filter(
        (item) => item.status_budget.id !== 2 && item.status_budget.id !== 5
      );

      if (pending.length >= 2) {
        return pending.slice(0, 2);
      }

      if (pending.length) {
        if (approved.length) return [pending[0], approved[0]];
        return [pending[0], rest[0]];
      }

      if (approved.length >= 2) {
        return approved.slice(0, 2);
      }

      if (approved.length) {
        return [approved[0], rest[0]];
      }

      return rest.slice(0, 2);
    },
  },
};
</script>

<style scoped>
.budget-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
}

.budget-list > * {
  flex: 1 1 100%;
  min-width: 0;
}

.highlighted {
  background: #e1f5fe;
}
.highlighted:hover {
  background: #ecf9ff;
}

.regular {
  background: #eeeeee;
}
.regular:hover {
  background: #fafafa;
}

@media (max-width: 959px) {
  .showAll {
    display: flex;
    justify-content: center;
  }
}

@media (min-width: 960px) {
  .budget-list > * {
    flex: 1 1 calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
  }

  .showAll {
    display: flex;
    justify-content: flex-start;
  }
}
</style>
